import ChevronLeft from 'components/Icons/ChevronLeft';
import React from 'react';

interface Props {
  title: string;
  onBackClick?: () => void;
}

class ModalSidebarHeader extends React.Component<Props> {
  render(): React.ReactNode {
    const { title, onBackClick } = this.props;

    return (
      <div className="bgd-primary-blue hs3 white-1 row items-center p4">
        {onBackClick ? (
          <div
            className="hrem-1p5 flex-center fill-white mr3 cursor-pointer"
            onClick={onBackClick}
          >
            <ChevronLeft width="9px" height="16px" />
          </div>
        ) : null}
        <div className="medium font-size-4 white-1">{title}</div>
      </div>
    );
  }
}

export default ModalSidebarHeader;
